import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Google24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      d="M12.143 11.429V14h4.05c-.162 1.104-1.224 3.236-4.05 3.236-2.439 0-4.429-2.122-4.429-4.736s1.99-4.736 4.429-4.736c1.388 0 2.316.622 2.847 1.157l1.939-1.96C15.684 5.739 14.07 5 12.143 5 8.193 5 5 8.354 5 12.5S8.194 20 12.143 20C16.265 20 19 16.957 19 12.671c0-.492-.051-.867-.112-1.242h-6.745z"
      fillRule="evenodd"
    />
  </svg>
);

export default Google24;
